let _canvas: HTMLCanvasElement = null;

/**
 * @return {HTMLCanvasElement}
 */
export function CanvasGet(): HTMLCanvasElement
{
    return _canvas;
}

/**
 * @return {void}
 */
export function CanvasInit(): void
{
    _canvas = document.getElementById('3d') as HTMLCanvasElement;
}
